import type { QueryClient } from '@lib/query/client';
import { spaceTreeQueryKeys } from '@lib/space-tree/constants/space-tree-query-keys';

import { insightQueryKeys } from './insight-query-keys';

/**
 * Everything a reprocess can change. Re-running the pipeline
 * re-sorts the document, so the space tree moves along with
 * the document lists and the rail.
 *
 * Single-document and batch retries share this so one cannot
 * quietly refresh less than the other.
 */
export function invalidateInsightReprocessQueries(queryClient: QueryClient) {
  const keys = [
    insightQueryKeys.documents(),
    insightQueryKeys.dataTableAll(),
    insightQueryKeys.quickSearchAll(),
    insightQueryKeys.processingQueue(),
    spaceTreeQueryKeys.all,
  ];

  for (const queryKey of keys) {
    queryClient.invalidateQueries({ queryKey });
  }
}
